import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/main.css';

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { item, qty, totalPrice } = location.state || {};

  return (
    <div className="royal-background" style={{ padding: '2rem', color: '#fff', textAlign: 'center' }}>
      <h2 style={{ color: '#ffd700' }}>🎉 Thank You for Your Order!</h2>
      <p style={{ marginTop: '1.2rem', fontSize: '1.15rem', color: '#ffd700cc' }}>
        Your royal feast is being prepared with utmost care and will be on its way to your doorstep soon.<br />
        Sit back, relax, and get ready to enjoy a delicious meal!
      </p>
      {item && (
        <div style={{ marginTop: '2rem', backgroundColor: '#002c6a', padding: '1.5rem', borderRadius: '12px', display: 'inline-block' }}>
          <h3>{item.name}</h3>
          <p>Quantity: {qty}</p>
          <p>Total Paid: ₹{totalPrice}</p>
        </div>
      )}
      <div style={{ marginTop: '2rem' }}>
        <button className="primary-btn" onClick={() => navigate('/')}>Back to Home</button>
      </div>
    </div>
  );
};

export default ThankYou;
